// import * as home from './home'
import * as user from './user'
// import * as usercenter from './usercenter'
// import * as bank from './bank'
// import * as items from './items'
// import * as settings from './settings'

export {user}



// WEBPACK FOOTER //
// ./src/api/index.js